import { render, staticRenderFns } from "./Academics.vue?vue&type=template&id=74969d19"
import script from "./Academics.vue?vue&type=script&lang=js"
export * from "./Academics.vue?vue&type=script&lang=js"
import style0 from "./Academics.vue?vue&type=style&index=0&id=74969d19&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports